module.exports = __webpack_public_path__ + "static/img/0-1home6.7b32c071.png";